import * as React from "react";
import { BrComponent } from "@bloomreach/react-sdk";
import { generateConditionalClassNames, removeWhiteSpaceChars, scrollToNextTab } from "../../../../utils/containers/RowComponent/utils/utils.js";
import { RowTabButton } from "./RowTabButton.js";
/* empty css            */
const CmsRowTab = ({ component }) => {
  const { showInDesktop, showInTablet, showInPhone, fullWidth, ...cssStyles } = component.getParameters();
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const tabRefs = React.useRef(Array(component.getChildren().length).fill(null));
  const tabButtonsTitles = component.getChildren().map((row) => row.getParameters().tabButtonTitle);
  const [selectedTab, setSelectedTab] = React.useState(0);
  const handleClick = (index) => {
    setSelectedTab(index);
    scrollToNextTab(tabRefs, index);
  };
  const handleNextTab = (nextTab) => {
    setSelectedTab(nextTab);
    tabRefs.current[nextTab].focus();
    scrollToNextTab(tabRefs, nextTab);
  };
  const handleKeyPress = (event) => {
    const tabCount = Object.keys(tabButtonsTitles).length;
    if (event.key === "ArrowLeft") {
      const nextTab = selectedTab - 1;
      if (nextTab >= 0) {
        handleNextTab(nextTab);
      }
    }
    if (event.key === "ArrowRight") {
      const nextTab = selectedTab + 1;
      if (nextTab < tabCount) {
        handleNextTab(nextTab);
      }
    }
  };
  const rowClassName = generateConditionalClassNames("br-row-tabs", {
    fullWidth,
    showInDesktop,
    showInTablet,
    showInPhone
  });
  return /* @__PURE__ */ React.createElement("section", { className: rowClassName, "data-t": "br-row-tabs", style: { ...filteredStyles } }, /* @__PURE__ */ React.createElement("div", { className: "br-row-tabs_buttons", "data-t": "br-row-tabs_buttons" }, /* @__PURE__ */ React.createElement("ul", { role: "tablist", "aria-label": "List of tabs", onKeyDown: handleKeyPress }, Object.keys(tabButtonsTitles).map((key, index) => /* @__PURE__ */ React.createElement(
    RowTabButton,
    {
      id: removeWhiteSpaceChars(`rowTabButton-${tabButtonsTitles[key]}`),
      tabRowId: removeWhiteSpaceChars(`rowTabPanel-${tabButtonsTitles[key]}`),
      index: parseInt(key),
      handleChange: handleClick,
      selectedTab,
      tabRef: (element) => {
        tabRefs.current[index] = element;
      },
      title: tabButtonsTitles[key],
      key
    }
  )))), /* @__PURE__ */ React.createElement("div", { className: "br-row-tabs_slides" }, /* @__PURE__ */ React.createElement("div", { className: "br-row-tabs_slides-wrapper" }, /* @__PURE__ */ React.createElement(BrComponent, null))));
};
export {
  CmsRowTab,
  CmsRowTab as default
};
//# sourceMappingURL=RowTab.js.map
